"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceEnabledType = void 0;
const GeoModelCommon_1 = require("../Geo/GeoModelCommon");
const ThingShadowState_1 = require("../ThingShadowState");
const debug = !process.env.AWS_SESSION_TOKEN && false;
class DeviceEnabledType extends GeoModelCommon_1.GeoModelCommon {
    constructor(type, { ...ob } = {}) {
        super({ type, ...ob });
        this.deviceBatteryPercentage = null;
        this.deviceBatteryVoltage = null;
        this.batteryRemainingDays = ob.batteryRemainingDays ?? this.batteryRemainingDays;
        this.deviceBatteryPercentage = ob.deviceBatteryPercentage ?? this.deviceBatteryPercentage;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? this.deviceBatteryVoltage;
        this.deviceEuis = ob.deviceEuis ?? this.deviceEuis;
    }
    get shadow() {
        if (!(this.ThingShadowState instanceof Array))
            this.ThingShadowState = [];
        const lastTSS = this.ThingShadowState[0];
        let shadow = undefined;
        if (lastTSS instanceof ThingShadowState_1.ThingShadowState)
            shadow = this.ThingShadowState[0].payload.state;
        return shadow;
    }
    set shadow(payloadWithshadow) {
        debug &&
            console.log('Setting shadow with ', {
                TSS: this.ThingShadowState,
                payloadWithshadow,
            });
        if (!(this.ThingShadowState instanceof Array && this.ThingShadowState[0] instanceof ThingShadowState_1.ThingShadowState)) {
            this.ThingShadowState = [new ThingShadowState_1.ThingShadowState(payloadWithshadow)];
            debug && console.log('initialized shadow to', payloadWithshadow);
        }
        if (this.ThingShadowState.length > 0) {
            let update;
            if (payloadWithshadow?.payload.state)
                update = payloadWithshadow.payload;
            else if (payloadWithshadow.state)
                update = payloadWithshadow;
            const lastTSS = this.ThingShadowState[0].mergePayload(update);
            this.ThingShadowState.unshift(lastTSS);
            debug && console.log('updated and set head to', lastTSS);
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.DeviceEnabledType = DeviceEnabledType;
